
import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {commitAddNotification} from '@/store/main/mutations';
import {acceptableFiles, rules} from '@/utils';


import DefaultHelp from '@/components/tooltips/DefaultHelp.vue';

@Component({
  components: {DefaultHelp},
})
export default class FileUpload extends Vue {
  @Prop(String) private label!: string;
  @Prop(String) private message!: string;
  @Prop() private objChange!: string;
  @Prop(Boolean) private required!: boolean;
  private fileModel: any = null;
  private rules: any = rules;
  private acceptableFiles: any = acceptableFiles;

  // private get requiredLocal() {
  //   return this.required || false
  // }

  private get fieldRules() {
    const _rules = this.rules.maxSizeFile(100).concat(this.rules.acceptableFiles);
    if (this.required) {
      _rules.concat(this.rules.required);
    }
    return _rules;
  }

  private async toBase64(value) {
    let fileInfos = '';
    if (value instanceof Blob) {

      // if (value.type !== 'application/pdf') {
      if (!this.acceptableFiles.find((e) => e === value.type)) {
        commitAddNotification(this.$store, {
          content: `${this.$t('infos.invalid_file_type')} PDF, JPEG ou PNG.`,
          color: 'error',
        });
        this.fileModel = null;
        return;
      }

      const converted = await new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(value);
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = (error) => reject(error);
      });

      // @ts-ignore
      fileInfos = {
        // @ts-ignore
        name: value.name, type: value.type, compressed_size: converted.length,
        original_size: value.size, data_base64: converted, form_files_id: 0,
      };
    }
    // this.objChange = fileInfos;
    this.$emit('parsed-value', fileInfos);

  }


}
